<template>
  <div class="bodycontent">
    <div class="page_title">
      打印机设置
    </div>
    <div style="margin-top: 15px">
      <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
    </div>
    <div class="table_box">
      <el-table :data="listData" border>
        <el-table-column label="打印机名称" prop="name"></el-table-column>
        <el-table-column label="打印机终端号" prop="device_no"></el-table-column>
        <el-table-column label="打印机key值" prop="device_key"></el-table-column>
        <el-table-column label="打印小票张数" prop="times"></el-table-column>
        <el-table-column label="门店" prop="show_store"></el-table-column>
        <el-table-column label="是否开启" prop="show_open"></el-table-column>
        <el-table-column label="操作" width="140px">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row.id)">修改</el-button>
            <el-button type="text" @click="delItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      layout="prev, pager, next, total, jumper"
      :current-page="page"
      :total="total"
      :page-size="10"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <el-dialog :visible.sync="showForm" width="600px" :title="formTitle" @close="closeForm" :close-on-click-modal="false" :show-close="false">
      <div class="page_form" v-loading="dialogLoading">
        <el-form :model="formData" size="small" label-width="120px">
          <el-form-item label="打印机名称">
            <el-input v-model="formData.name" style="width:310px"></el-input>
          </el-form-item>
          <el-form-item label="绑定打印机">
            <el-input class="input_box" v-model="formData.device_no" placeholder="设备终端号"></el-input>
            <el-input class="input_box" v-model="formData.device_key" placeholder="设备key值"></el-input>
            <div class="form_info_text">请填写打印机设备终端号和key值</div>
          </el-form-item>
          <el-form-item label="小票打印张数">
            每个付款单自动打印
            <el-input class="input_box_small" v-model="formData.times" size="small"></el-input>
            张
          </el-form-item>
          <el-form-item label="是否开启打印">
            <el-checkbox v-model="formData.is_open">开启打印</el-checkbox>
          </el-form-item>
          <el-form-item label="门店">
            <el-select v-model="formData.room_id">
              <el-option v-for="item in storeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="bottom_btn">
          <el-button size="medium" @click="closeForm">取消</el-button>
          <el-button size="medium" type="primary" @click="save">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getPrinterList, addPrinter, editPrinter, detailPrinter, delPrinter } from "@/api/set";
import { storeSelect } from "@/api/employee";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      listData: [], // 数据列表
      page: 1,
      total: 0, 
      storeList: [], // 门店选项
      showForm: false, 
      formTitle: "新增打印设置",
      is_add: true, // 保存/修改
      formData: {
        name: "",
        device_no: "",
        device_key: "",
        times: "",
        is_open: true,
        room_id: ""
      },
      dialogLoading: false,
    }
  },
  mounted(){
    this.init();
  },
  methods:{
    init(){
      storeSelect({app_id: this.app_id}).then(res => {
        if(res.code == 200){
          this.storeList = res.data;
          this.getData();
        }else{
          this.$message(res.msg)
        }
      })
    },
    getData(){
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      }
      getPrinterList(data).then(res => {
        if(res.code == 200){
          this.listData = res.data;
          this.total = res.total
          this.listData.forEach(item => {
            item.show_open = item.is_open == 1? "是":"否";
            item.show_store = item.room_id? this.storeList.find(x => x.id == item.room_id).name:"";
          })
        }else{
          this.$message(res.msg);
        }
      })
    },
    handleCurrentChange(val){
      this.page = val;
      this.getData();
    },
    closeForm(){
      this.showForm = false;
      this.formData = {
        name: "",
        device_no: "",
        device_key: "",
        times: "",
        is_open: true,
        room_id: ""
      }
    },
    addItem(){
      this.formTitle = '新增打印设置';
      this.is_add = true;
      this.showForm = true;
    },
    save(){
      var data = Object.assign({},this.formData);
        data.is_open = data.is_open? 1:0;
        data.app_id = this.app_id;
      if(this.is_add){
        addPrinter(data).then(res => {
          if(res.code == 200){
            this.$message.success('保存成功');
            this.closeForm();
            this.getData();
          }else{
            this.$message(res.msg)
          }
        })
      }else{
        editPrinter(data).then(res => {
          if(res.code == 200){
            this.$message.success('保存成功');
            this.closeForm();
            this.getData();
          }else{
            this.$message(res.msg)
          }
        })
      }
    },
    delItem(row){
      this.$confirm("确认删除吗？")
        .then(() => {
          delPrinter({
            app_id: this.app_id,
            id: row.id
          }).then(res => {
            if(res.code == 200){
              this.$message.success("删除成功");
              this.getData();
            }else{
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    editItem(id){
      this.formTitle = "修改打印设置";
      this.is_add = false;
      this.dialogLoading = true;
      this.showForm = true;
      var data = {
        app_id: this.app_id,
        id: id
      }
      detailPrinter(data).then(res => {
        if(res.code == 200){
          this.formData = res.data;
          this.formData.is_open = res.data.is_open == 1? true:false;
          this.formData.id = id;
          delete this.formData.create_time;
        }else{
          this.$message(res.msg)
        }
        this.dialogLoading = false;
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bodycontent{
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding:0 18px;
  .page_title{
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .table_box{
    margin: 10px 0;
  }
}
.page_form{
  .input_box{
    width: 150px;
    margin-right: 10px;
  }
  .input_box_small{
    width: 50px;
  }
  .form_info_text{
    color: #aaa;
  }
  .bottom_btn{
    margin-top: 40px;
    text-align: center;
  }
}
</style>